import { isFunction } from "utils/isFunction";

import { useTranslation } from "react-i18next";
import Tooltip from "components/layout/Tooltip";
import { ButtonPrimary } from "components/layout/Button/ButtonPrimary";

export const ActionButton = ({
	buttonKey,
	editor,
	label,
	disabled,
	onClick,
	tooltipInfo,
}) => {
	const { t } = useTranslation(["common"]);

	return (
		<Tooltip
			text={disabled ? tooltipInfo : ""}
			wrapperStyle={{
				position: "relative",
				left: 0,
				right: 0,
				top: 0,
				bottom: 0,
			}}
		>
			<ButtonPrimary
				key={buttonKey || "action-button"}
				onMouseDown={(event) => {
					event.preventDefault();
					event.stopPropagation();
				}}
				onMouseUp={(event) => {
					event.preventDefault();
					event.stopPropagation();
				}}
				onClick={(event) => {
					event.preventDefault();
					event.stopPropagation();

					editor.current.focus();

					if (isFunction(onClick)) {
						const { plain, parsed } = editor.current.serialize();
						onClick(event, plain, parsed);
					}
				}}
				label={label || t("common:send")}
				disabled={disabled}
				noBoxShadow
			/>
		</Tooltip>
	);
};
